export class TableHeader {
  field: string;
  header: string;
  rating?: boolean;
  image?: boolean;
}
